// TopBar.js — DEPRECATED em v3 (shell architecture, 2026-05-10)
//
// Toda a lógica de navegação (logos, menu items, hamburger, logout, atualizar
// versão, sêmen modal) foi migrada para src/components/layout/AppSidebar.js.
//
// Este componente retorna null. O export continua existindo para que os ~46
// imports em pages compilem sem erro.
//
// TODO (Phase 8): remover este arquivo e os imports nas pages quando 100%
// migrados. Verificar com: grep -rl "import TopBar" src/pages/

import React from 'react'
import { connect } from 'react-redux'

// Retorna null — AppShell já renderiza AppSidebar com toda a navegação.
const TopBar = () => null

const mapStateToProps = (state) => ({
  currentSync: state.sync.currentSync,
})

// connect mantido para que pages que usam TopBar com connect não quebrem.
export default connect(mapStateToProps)(TopBar)
